const educationFundStatuses = {
  ceiling: 'ceiling',
  whole: 'whole',
  none: 'none',
};

module.exports = { educationFundStatuses };
